import { FontFamilies } from '@persona-id/design-tokens';

export const fontFamilyCss = (fontFamily?: string): string =>
  fontFamily != null ? `'${fontFamily}', sans-serif` : FontFamilies.Primary;
